// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMq from 'vue-mq'
import { store } from './store'
import vueSmoothScroll from 'vue-smooth-scroll'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VModal from 'vue-js-modal'
import { isMobile } from 'mobile-device-detect'
import GAuth from 'vue-google-oauth2'
import VueGtm from 'vue-gtm'
import VueCookies from 'vue-cookies'

Vue.config.productionTip = false

Vue.use(vueSmoothScroll);
Vue.use(VueAxios, axios);
Vue.use(VModal);
Vue.use(VueMq, {
	breakpoints: {
		mobile: 1024,
		laptop: 1334,
		wide: Infinity
	}
});
Vue.use(GAuth, {
    clientId: '202884313085-oo69hi3gu74og4a6hjrdeqh0o5dr8t1n.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'select_account'
});
Vue.use(VueGtm, {
    id: 'GTM-5W75CH7', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
});

/* eslint-disable no-new */
new Vue({
	el: '#app',
	store,
	router,
	components: { App },
	template: '<App/>',
	beforeCreate() {
		/*
		var baseurl = 'https://todomath.onelink.me/aPeT?af_prt=aone&is_retargeting=true&af_click_lookback=1d&af_sub1=nru&af_sub2=apt&af_channel=sa&af_force_deeplink=true'
		var pid = "&pid="
		var c = "&c=sa_mo_apt"
		var af_adset = "&af_adset="
		var af_sub3 = "&af_sub3="
		var af_sub4 = "&af_sub4="
		var af_sub5 = "&af_sub5="
		var af_ad = "&af_ad="
		var af_keywords = "&af_keywords="

		if (this.$route.query["n_keyword"]) {
			pid += "naver"
			af_adset += this.$route.query["n_ad_group"]
			af_sub3 += this.$route.query["n_ad"]
			af_sub4 += this.$route.query["n_query"]
			af_sub5 += this.$route.query["n_rank"]
			af_ad += this.$route.query["n_keyword"]
			af_keywords += this.$route.query["n_keyword"]
		} else if (this.$route.query["DMKW"]) {
			pid += "daum"
			af_adset += this.$route.query["d_ad_group"]
			af_sub3 += this.$route.query["d_ad"]
			af_sub4 += this.$route.query["DMSKW"]
			af_sub5 += this.$route.query["d_rank"]
			af_ad += this.$route.query["DMKW"]
			af_keywords += this.$route.query["DMKW"]
		} else if (this.$route.query["GGKW"]) {
			pid += "google"
			af_adset += this.$route.query["g_ad_group"]
			af_sub3 += this.$route.query["g_ad"]
			af_sub4 += this.$route.query["g_query"]
			af_sub5 += this.$route.query["g_rank"]
			af_ad += this.$route.query["GGKW"]
			af_keywords += this.$route.query["GGKW"]
		} else {
			baseurl += "&pid=Unknown"
		}


		var setUrl;
		if (isMobile) {
			setUrl = baseurl + pid + c + af_adset + af_sub3 + af_sub4 + af_sub5 + af_ad + af_keywords;
		} else {
			setUrl = "https://todomath.onelink.me/aPeT";
		}
		*/

		this.$store.commit('setAppStoreUrl', 'https://apps.apple.com/app/id666465255');
		this.$store.commit('setGooglePlayUrl', 'https://play.google.com/store/apps/details?id=com.enuma.todomath')
    	this.$store.commit('setCnStaticDownloadUrl', "https://todomath-apk-download.s3.cn-north-1.amazonaws.com.cn/todomath-release.apk");
	},
	watch: {
		$mq: function (val) {
			var width = '';
			switch (val) {
				case 'mobile':
					width = 720;
					break;
				case 'laptop':
					width = 1024;
					break;
				case 'wide':
					width = 1334;
					break;
				default:
					width = 720;
					break;

			}
			document.getElementById("viewport").setAttribute("content", "width=" + width + ", shrink-to-fit=no");
		}
	}

})



// WEBPACK FOOTER //
// ./src/main.js